import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const File: React.FC<SvgProps> = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <path
        d="M2.4873 2.48749C2.4873 1.474 3.31131 0.649994 4.3248 0.649994H8.91855V4.32499C8.91855 4.83318 9.32912 5.24374 9.8373 5.24374H13.5123V13.5125C13.5123 14.526 12.6883 15.35 11.6748 15.35H4.3248C3.31131 15.35 2.4873 14.526 2.4873 13.5125V2.48749ZM13.5123 4.32499H9.8373V0.649994L13.5123 4.32499Z"
        fill="currentColor"
      />
    </Icon>
  )
}
